import { MuiComponent } from "./type";
import * as Colors from "../colors";

export const MuiPopover: MuiComponent<"MuiPopover"> = {
  styleOverrides: {
    paper: {
      marginTop: "12px",
      backgroundColor: Colors.Surface,
      borderRadius: "12px",
      color: "#fff",
      padding: "12px 16px",
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.4)",
      minWidth: "250px",
      border: `1px solid ${Colors.BorderGray}`,
      position: "relative",
      width: "fit-content",
      overflow: "visible",

      "&::before": {
        content: '""',
        position: "absolute",
        top: "-7px",
        left: "50%",
        transform: "translateX(-50%) rotate(45deg)",
        width: "12px",
        height: "12px",
        backgroundColor: Colors.Surface,
        borderLeft: `1px solid ${Colors.BorderGray}`,
        borderTop: `1px solid ${Colors.BorderGray}`,
        zIndex: 10,
      },
    },
  },
};
